import { keys, messages } from './messages'
import { localStorages, sessionStorages } from './localStorages'
import _ from 'lodash'
import axios from 'axios'
import config from '../config/axiosConf'
import vue from '../main'
import encryptUtil from './gatewayEncrypt'

// 初始化
const defaultsConfig = {
  baseURL: config.baseUrl,
  timeout: 60 * 60 * 1000, // 导入人员数据库耗时多
  withCredentials: true,
  headers: {
    "X-enc-key": encryptUtil.getHeader(),
    post: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    // 'Access-Control-Allow-Origin': '*',
    'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1,private'
  }
  // fileUploadUrl: localStorages.getItem('fileUploadUrl'),
  // fileLoadUrl: localStorages.getItem('fileLoadUrl')
}
_.merge(axios.defaults, defaultsConfig)

// 白名单过滤，不传token
function checkWhiteList (url = '', type = 'login') {
  const whiteList = {
    login: ['account/login', 'account/forgetPasswd', 'people/findOneByQuery', 'phoneCode/', 'phoneCode/send', 'checkCode', 'account/tokenVerify', 'cas/id_token', 'sj/getToken', 'sj/getUserInfo', 'sj/getCsInfos', 'account/loginByJaccount'],
    tenant: ['account/login', 'account/forgetPasswd', 'people/findOneByQuery', 'phoneCode/', 'phoneCode/send', 'checkCode', 'account/tokenVerify', '/place/updateOne', 'sj/getToken', 'sj/getUserInfo', 'sj/getCsInfos', 'account/loginByJaccount']
  }
  return whiteList[type].some(v => url.endsWith(v))
}
// 请求发送前拦截
axios.interceptors.request.use(requestConfig => {
  // 网关测试，不同域名请求不同网关
  // const path = requestConfig.url.split(config.baseUrl)[1]
  // requestConfig.url = `${window.location.protocol}//${window.location.host}/api/iobp/${path}`
  // console.log(requestConfig)
  if (!checkWhiteList(requestConfig.url || requestConfig.baseURL)) {
    // console.log('nowhitelist: ', requestConfig.url, requestConfig.baseURL)
    const token = localStorages.getItem('id_token') || requestConfig.data.idToken;
    console.warn('token', token)
    console.log(requestConfig)
    if (token && token.length > 0) {
      requestConfig.headers.common['Authorization'] = 'Bearer ' + token
      // 登陆后，浏览器其他tab登录了其他账号，改写了localStorage里的用户信息，重新findOne人员信息，校验身份
      let localIdentity = localStorages.getItem('userId')
      let sessionIdentity = sessionStorages.getItem('userId')
      if (localIdentity && sessionIdentity && sessionIdentity !== localIdentity) { // 为空的情况不重新findOne人员
        sessionStorages.setItem('userId', localIdentity)
        vue.$store.dispatch(keys.account.update)
      }
    } else {
      // let msg = messages.nologininfo.copy()
      let msg = messages.tokeninvalidate.copy()
      msg.requestConfig = requestConfig
      console.warn(requestConfig.url + ' >>> request no auth: ', msg)
      return Promise.reject(msg)
    }
  } else {
    console.log('login whitelist: ', requestConfig.url, requestConfig.baseURL)
  }

  let bodyParamsToUrl = false
  // 请求中加上tenantId
  if (!checkWhiteList(requestConfig.url || requestConfig.baseURL, 'tenant')) {
    let tenantId = localStorages.getItem("tenantId")
    if (!tenantId) { // 未选择租户（未登录时的login、menuTree接口，其他业务接口在调用前会检查tenantId），或者租户信息为falsy
      tenantId = "allinone"
    }
    // get, delete请求加在params里；put, post请求加在body里
    if (["get", "delete"].includes(requestConfig.method)) {
      if (_.isEmpty(requestConfig.params)) {
        requestConfig.params = {
          params: { tenantId: tenantId }
        }
      }
      if (_.isEmpty(requestConfig.params.params)) {
        requestConfig.params.params = { tenantId: tenantId }
      }
      if (_.isEmpty(requestConfig.params.params.tenantId)) {
        requestConfig.params.params.tenantId = tenantId
      }
    }
    if (["put", "post", "patch"].includes(requestConfig.method)) {
      // 上传文件流不加密，参数放在formData里；加密环境，将formData里除file外的数据加密
      if (requestConfig.url.endsWith('device/importDevice') || requestConfig.url.endsWith('people/importPeople') || requestConfig.url.endsWith('view/upload') || requestConfig.url.endsWith('view/checkUpload') || requestConfig.url.endsWith('view/edit_view')) { // 上传文件时放data里iobp里获取不到，包含地图上传
        bodyParamsToUrl = true
        // requestConfig.headers.tenantId = tenantId
        requestConfig.data.append('tenantId', tenantId)
        if (requestConfig.url.endsWith('view/upload') || requestConfig.url.endsWith('view/edit_view')) {
          // requestConfig.headers.uploadPeople = localStorages.getItem("peopleId")
          // requestConfig.headers.viewName = requestConfig.data.get("viewName")
          // requestConfig.headers.remark = requestConfig.data.get("remark")
          // requestConfig.data.append('uploadPeople', localStorages.getItem("peopleId"))
          // if (requestConfig.data.get("id")) {
          //   // requestConfig.headers.id = requestConfig.data.get("id")
          // }
        }
      } else {
        if (_.isEmpty(requestConfig.data)) {
          requestConfig.data = { tenantId: tenantId }
        } else if (_.isEmpty(requestConfig.data.tenantId)) {
          requestConfig.data.tenantId = tenantId
        }
      }
    }
  } else {
    console.log('tenant whitelist: ', requestConfig.url, requestConfig.baseURL)
  }
  try {
    if (config.security) {
      if (bodyParamsToUrl) {
        // 加密formData里除file外的参数，api层从request.body里取到参数
        const formData = new FormData()
        const encryptToUrl = {}
        for (const [key, value] of requestConfig.data.entries()) {
          if (key === 'file') {
            formData.append('file', value)
          } else {
            encryptToUrl[key] = value
          }
        }
        console.log(encryptToUrl, 'encryptToUrl')
        for (const [key, value] of Object.entries(encryptUtil.getEncryptedObject(encryptToUrl))) {
          requestConfig.url = `${requestConfig.url}${requestConfig.url.indexOf('?') === -1 ? '?' : '&'}${key}=${value}`
        }
        requestConfig.data = formData
      } else {
        console.log(requestConfig.params, 'data before encrypt')
        if (requestConfig.params) requestConfig.params = encryptUtil.getEncryptedObject(requestConfig.params)
        if (requestConfig.data) requestConfig.data = encryptUtil.getEncryptedObject(requestConfig.data)
      }
    } else {
      if (bodyParamsToUrl) {
        // 加密formData里除file外的参数，api层从request.body里取到参数
        const formData = new FormData()
        const encryptToUrl = {}
        for (const [key, value] of requestConfig.data.entries()) {
          if (key === 'file') {
            formData.append('file', value)
          } else {
            encryptToUrl[key] = value
          }
        }
        console.log(encryptToUrl, 'encryptToUrl')
        for (const [key, value] of Object.entries(encryptToUrl)) {
          requestConfig.url = `${requestConfig.url}${requestConfig.url.indexOf('?') === -1 ? '?' : '&'}${key}=${value}`
        }
        requestConfig.data = formData
      }
    }
  } catch (error) {
    // 数据解析出错
    let msg = messages.errordataparse.copy()
    msg.requestConfig = requestConfig
    msg.error = error
    console.warn(requestConfig.url + ' >>> request dataencrypt error: ', msg)
    return Promise.reject(msg)
  }

  console.log(requestConfig, 'axios request')
  return requestConfig
})

// 请求返回拦截
axios.interceptors.response.use(
  response => {
    console.log(response)
    if (response.status !== 200) {
      // 网络通信出错
      let msg = messages.create.error(response.status, response.statusText)
      msg.response = response
      console.warn(response.config.url + ' >>> response network error: ', msg)
      msg.fireAsync()
      return Promise.reject()
    }

    if (config.security) {
      try {
        response.data = encryptUtil.getDecryptedObject(response.data)
      } catch (error) {
        // 数据解析出错
        let msg = messages.errordataparse.copy()
        msg.response = response
        msg.error = error
        console.warn(response.config.url + ' >>> response decrypt error: ', msg)
        msg.fireAsync()
        return Promise.reject()
      }
    }

    if (response.data.code === messages.tokeninvalidate.code || response.data.code === messages.noidtoken.code || response.data.msg === 'invalid token') {
      // 最好通过code来判断token是否有效
      // 身份信息过期，或身份信息无效，访问失败
      let msg = messages.tokeninvalidate.copy()
      msg.response = response
      console.warn(response.config.url + ' >>> response auth error: ', msg)
      msg.fireAsync()
      return Promise.reject()
    }

    // 人员findOne接口找不到，返回result: null
    // if (response.config) {
    //   const urlBlackList = [`${response.config.baseURL}people/findOne`]
    //   if (urlBlackList.includes(response.config.url) && response.data && !response.data.result) {
    //     let msg = messages.noaccessauth.copy()
    //     msg.message = "该用户没有权限"
    //     return Promise.reject(msg)
    //   }
    // }

    let data = response.data
    // 处理返回结果结构， msg -> message
    if (data.msg) {
      data.message = data.msg
      delete data.msg
    }

    if (data.code !== 200) {
      // 如果是业务错误，由具体业务处理
      console.warn(response.config.url + ' >>> response fail: ', data)
      return Promise.reject(data)
    }
    console.log(data);
    return data.result
  },
  fail => {
    let msg = fail
    if (fail && fail.response) {
      switch (fail.response.status) {
        case 401:
          msg = messages.unauthorized.copy()
          break
        case 502:
        case 503:
          msg = messages.unhealthyserver.copy()
          break
        default:
          break
      }
    }
    if (msg instanceof messages.create) {
      // request interceptors 的error msg，统一处理
      msg.fireAsync()
      // 仅回调失败，不需要结果
      return Promise.reject()
    } else if (msg.hasOwnProperty('code')) {
      console.warn(' >>> response fail: ', fail)
      // 请求正常，业务失败的error msg，回调结果给业务层
      return Promise.reject(msg)
    } else if (!msg.response || !msg.response.status) { // 网络异常
      msg = messages.errornetwork.copy()
      msg.fireAsync()
      return Promise.reject()
    } else {
      // 其他未知错误，包括http-status非2xx的异常
      console.warn(' >>> response unknown fail: ', fail)
      msg = messages.errorunkown.copy()
      msg.error = fail
      msg.fireAsync()
      // 仅回调失败，不需要结果
      return Promise.reject()
    }
  }
)

// 判断是否IE浏览器,并生成时间戳
// function timestamp (url) {
//   if (!!window.ActiveXObject || 'ActiveXObject' in window) {
//     var getTimestamp = new Date().getTime()
//     if (url.indexOf('?') > -1) {
//       url = url + '×tamp=' + getTimestamp
//     } else {
//       url = url + '?timestamp=' + getTimestamp
//     }
//   }
//   return url
// }
export default {
  upload: (url, data) => {
    let formData = new FormData()
    for (let key in Object.keys(data)) {
      let val = data[key]
      formData.append(key, val)
    }
    return axios.post(url, data)
  },
  // setAxiosGetPromise: (url, params) => params ? axios.get(timestamp(url), { params: params }) : axios.get(timestamp(url)),
  setAxiosGetPromise: (url, params) => params ? axios.get(url, { params: params }) : axios.get(url),
  setAxiosPostPromise: (url, data) => data ? axios.post(url, data) : axios.post(url),
  setAxiosPutPromise: (url, data) => data ? axios.put(url, data) : axios.put(url),
  setAxiosDeletePromise: (url, params) => params ? axios.delete(url, { params: params }) : axios.delete(url)
}



// WEBPACK FOOTER //
// ./src/utils/axios.js